import React from "react";
import styles from "./GalleryAmigurumis.module.css";
import llevaro1 from "../data/assets/Llaveros/Abeja/3.png";
import llevaro2 from "../data/assets/Llaveros/Dino/3.png";
import llevaro3 from "../data/assets/Llaveros/Hongo/0.png";
import llevaro4 from "../data/assets/Llaveros/ballena/ballena-2.png";
import llevaro5 from "../data/assets/Llaveros/comida/bao.png";
import llevaro6 from "../data/assets/Llaveros/comida/dona-1.png";
import llevaro7 from "../data/assets/Llaveros/comida/sushi.png";
import llevaro8 from "../data/assets/Llaveros/Dino/2.png";
import llevaro9 from "../data/assets/Llaveros/comida/onigiri.png";

function GalleryKeychain() {
  const data = [
    llevaro1,
    llevaro3,
    llevaro4,
    llevaro2,
    llevaro9,
    llevaro5,
    llevaro6,
    llevaro7,
    llevaro8,
  ];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Llaveros y colgantes</h2>
      <div className={styles.gallery}>
        {data.map((item, i) => (
          <figure className={styles.item} key={i}>
            <img src={item} alt="foto" className={styles.image}></img>
          </figure>
        ))}{" "}
      </div>
    </div>
  );
}

export { GalleryKeychain };
